import { RouteObject } from 'react-router-dom';
import SettingAndPrivacy from '~/modules/myAccount/pages/SettingAndPrivacy';
import { RoutesEnum } from '~/constants/enums';
import EmailUpdate from '~/modules/myAccount/pages/SettingAndPrivacy/EmailUpdate';
import PasswordUpdate from '~/modules/myAccount/pages/SettingAndPrivacy/PasswordUpdate';
import PhoneUpdate from '~/modules/myAccount/pages/SettingAndPrivacy/PhoneUpdate';

const routes: RouteObject[] = [
  {
    path: RoutesEnum.SETTINGS_AND_PRIVACY,
    children: [
      {
        index: true,
        element: <SettingAndPrivacy />,
      },
      {
        path: RoutesEnum.UPDATE_EMAIL,
        element: <EmailUpdate />,
      },
      { path: RoutesEnum.UPDATE_PASSWORD, element: <PasswordUpdate /> },
      { path: RoutesEnum.UPDATE_PHONE_NUMBER, element: <PhoneUpdate /> },
    ],
  },
];
export default routes;
